/**
 * File System Access Component
 * UI for requesting directory access
 */

import { useState } from 'react';
import { getFileSystemManager } from '../lib/file-system-api';

export function FileSystemAccess() {
  const [hasAccess, setHasAccess] = useState(false);
  const [currentDirectory, setCurrentDirectory] = useState(null);
  const [isRequesting, setIsRequesting] = useState(false);

  const requestAccess = async () => {
    setIsRequesting(true);
    try {
      const fsm = getFileSystemManager();
      const granted = await fsm.requestDirectoryAccess();

      if (granted) {
        setHasAccess(true);
        setCurrentDirectory(fsm.getCurrentDirectory());
      }
    } catch (error) {
      console.error('[FileSystemAccess] Error:', error);
    } finally {
      setIsRequesting(false);
    }
  };

  if (hasAccess) {
    return (
      <div className="file-system-access success">
        <span className="status-icon">✅</span>
        <span className="status-text">
          Directory: <strong>{currentDirectory}</strong>
        </span>
        <span className="status-hint">
          Files will be created here
        </span>
      </div>
    );
  }

  return (
    <div className="file-system-access">
      <span className="status-icon">📁</span>
      <span className="status-text">
        File operations will download as ZIP
      </span>
      <button
        onClick={requestAccess}
        disabled={isRequesting}
        className="request-access-btn"
      >
        {isRequesting ? 'Requesting...' : 'Grant Folder Access'}
      </button>
      <span className="status-hint">
        Click to select a folder for real-time file creation
      </span>
    </div>
  );
}

export default FileSystemAccess;
